import { useEffect } from 'react';

export const useNewRelic = () => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      const newRelicTag = document.createElement('script');
      newRelicTag.src = '/newRelic.js';
      newRelicTag.async = true;
      document.head.appendChild(newRelicTag);
    }
  });
};
